/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMonitoredObjectGroupNested,
    ReadOnlyMonitoredObjectGroupNestedFromJSON,
    ReadOnlyMonitoredObjectGroupNestedFromJSONTyped,
    ReadOnlyMonitoredObjectGroupNestedToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20025
 */
export interface InlineResponse20025 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20025
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20025
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20025
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMonitoredObjectGroupNested>}
     * @memberof InlineResponse20025
     */
    results: Array<ReadOnlyMonitoredObjectGroupNested>;
}

export function InlineResponse20025FromJSON(json: any): InlineResponse20025 {
    return InlineResponse20025FromJSONTyped(json, false);
}

export function InlineResponse20025FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20025 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMonitoredObjectGroupNestedFromJSON)),
    };
}

export function InlineResponse20025ToJSON(value?: InlineResponse20025 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMonitoredObjectGroupNestedToJSON)),
    };
}


